import { Block, CRRender } from '@/components/crRender';
import { FormateDate } from '@/utils/varsManipulations'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import './style.css'
import { HOSPITAL_STATUS } from '@/data/hospitalStatus';

const CountDownCell = ({ orderDate, orderStatusId, sla = 72, providerResponseDate }: { orderDate: string, orderStatusId: number, sla: number, providerResponseDate: string }) => {

    const [timeLeft, setTimeLeft] = useState(null);

    const deadline = useMemo(() => moment(orderDate).add(sla, "hours"), [orderDate]);
    useEffect(() => {
        const interval = setInterval(() => {
            const diff = deadline.diff(moment());

            const duration = moment.duration(diff);

            const hours = Math.max(0, duration.hours()) + duration.days() * 24;
            const minutes = Math.max(0, duration.minutes());
            const seconds = Math.max(0, duration.seconds());

            setTimeLeft({ hours: `0${hours}`.slice(-2), minutes: `0${minutes}`.slice(-2), seconds: `0${seconds}`.slice(-2) });
        }, 1000);
        return () => clearInterval(interval);
    }, [orderDate, sla, providerResponseDate]);

    return (
        <td className="rd-new-badge">
            <Block isRender={!!providerResponseDate} className="rd-order-date">{FormateDate(providerResponseDate)}</Block>

            <CRRender isRender={!providerResponseDate}>
                <div className="rd-order-date">{FormateDate(orderDate)}</div>
                <CRRender isRender={orderStatusId == HOSPITAL_STATUS.Pending}>
                    <Block tooltipName="time-left-to-request-expired-for-provider" isRender={timeLeft} className="rd-time-left">
                        <span className="rd-time-left-days">    <span className="rd-time-left-separator"> {timeLeft?.hours} : {timeLeft?.minutes} : {timeLeft?.seconds} </span> </span>
                    </Block>
                </CRRender>
            </CRRender>
        </td>
    )
}

export default CountDownCell